import clientHttp from '@/services/clientHttp';
import type { DocumentNode } from 'graphql';
import { print } from 'graphql';
import type { QueryVariables } from 'villus';

const fetcherMethods = () => {
  const query = async (docs: DocumentNode, variables = {}, retry = 3) => {
    const result = await clientHttp
      .post('', {
        query: print(docs),
        ...variables,
      })
      .catch((err) => {
        if (err.abnormalCode) {
          console.log(`query - 异常提示`, err);
        } else {
          if (retry > 1) {
            console.log(`query - 请求重试`, err);
            return retryFetch('query', docs, variables, retry - 1);
          }
        }
        return Promise.reject(err);
      });

    // 兼容旧有数据格式
    return { data: { value: result?.data } };
  };

  const mutation = async (docs: DocumentNode, variables: QueryVariables = {}, retry = 3) => {
    const result = await clientHttp
      .post('', {
        query: print(docs),
        variables,
      })
      .catch((err) => {
        if (err.abnormalCode) {
          console.log(`mutation - 异常提示`, err);
        } else {
          if (retry > 1) {
            console.log(`mutation - 请求重试`, err);
            return retryFetch('mutation', docs, variables, retry - 1);
          }
        }
        return Promise.reject(err);
      });

    // 兼容旧有数据格式
    return { data: result?.data };
  };

  return {
    query,
    mutation,
  };
};

export const fetcher = fetcherMethods();

/**
 * 请求重发
 * @param docs
 * @param variables
 * @param retry
 */
const retryFetch = (
  method: 'query' | 'mutation',
  docs: DocumentNode,
  variables = {},
  retry: number
) => {
  setTimeout(() => {
    fetcher[method](docs, variables, retry);
  }, 1000);
};
